import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OfficialAccommodationLinkProps {
  accommodationId: string;
}

// Opens the official REPAT accommodation in a new tab
export const OfficialAccommodationLink: React.FC<OfficialAccommodationLinkProps> = ({
  accommodationId,
}) => (
  <Button variant="ghost" size="sm" asChild>
    {/* The session token lives in sessionStorage, which Chrome copies to a new tab only when
        it keeps its opener; with the default noopener the tab opens on the login page */}
    <a href={`/accommodation/${accommodationId}`} target="_blank" rel="opener">
      <ExternalLink className="mr-1 h-4 w-4" />
      Ver ficha
    </a>
  </Button>
);
